import React, { lazy, Suspense, useState, useEffect } from 'react';
import { useNavigate } from 'react-router'
import { BrowserRouter, Navigate, useLocation, Routes, Route, Link } from 'react-router-dom'
import { Provider, connect } from 'react-redux';

import Login from 'components/auth/Login';
import Logout from 'components/auth/Logout';
import store from 'store/store';
import Protected from 'components/Protected'
import { AxiosAdmin as Axios } from "connection/Axios"
// import Dashboard from 'components/pages/1-admin/dashboard/Dashboard';
// import Dashboard from 'components/pages/1-admin/dashboard/Dashboard';
import Dashboard from 'components/pages/0-general/dashboard/Dashboard';
// import Users_List from 'components/pages/1-admin/users/List';
// import Users_New from 'components/pages/1-admin/users/New';
import PropagateLoader from "react-spinners/PropagateLoader";
import { ToastContainer, toast } from 'react-toastify';


import 'App.css';
// import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap.rtl.min.css';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';

const Page403 = lazy(() => import('components/pages/0-general/errors/Page403'));
const Page404 = lazy(() => import('components/pages/0-general/errors/Page404'));


////////////// ADMIN
////////////// ADMIN
////////////// ADMIN
const Users_New = lazy(() => import('components/pages/1-admin/users/New'));
const Users_List = lazy(() => import('components/pages/1-admin/users/List'));
const Users_Edit = lazy(() => import('components/pages/1-admin/users/Edit'));
const Users_Details = lazy(() => import('components/pages/1-admin/users/Details'));
const Users_Activities = lazy(() => import('components/pages/1-admin/users/Activities'));
const Users_ResetPassword = lazy(() => import('components/pages/1-admin/users/ResetPassword'));

const Customers_New = lazy(() => import('components/pages/1-admin/customers/New'));
const Customers_List = lazy(() => import('components/pages/1-admin/customers/List'));
const Customers_Edit = lazy(() => import('components/pages/1-admin/customers/Edit'));
const Customers_Details = lazy(() => import('components/pages/1-admin/customers/Details'));
const Customers_Activities = lazy(() => import('components/pages/1-admin/customers/Activities'));
const Customers_ResetPassword = lazy(() => import('components/pages/1-admin/customers/ResetPassword'));
const Customers_Access = lazy(() => import('components/pages/1-admin/customers/Access'));

const Departments_New = lazy(() => import('components/pages/1-admin/departments/New'));
const Departments_List = lazy(() => import('components/pages/1-admin/departments/List'));
const Departments_Edit = lazy(() => import('components/pages/1-admin/departments/Edit'));
const Departments_Details = lazy(() => import('components/pages/1-admin/departments/Details'));

const Groups_New = lazy(() => import('components/pages/1-admin/groups/New'));
const Groups_List = lazy(() => import('components/pages/1-admin/groups/List'));
const Groups_Edit = lazy(() => import('components/pages/1-admin/groups/Edit'));
const Groups_Details = lazy(() => import('components/pages/1-admin/groups/Details'));

//////////// Professional Ver.
// const Categories_New = lazy(() => import('components/pages/1-admin/categories/New'));
// const Categories_List = lazy(() => import('components/pages/1-admin/categories/List'));
// const Categories_Details = lazy(() => import('components/pages/1-admin/categories/Details'));
// const Categories_Edit = lazy(() => import('components/pages/1-admin/categories/Edit'));

//////////// Simple Ver.
const Categories1_New = lazy(() => import('components/pages/1-admin/categories/l1/New'));
const Categories1_Search = lazy(() => import('components/pages/1-admin/categories/l1/Search'));
const Categories1_Tree = lazy(() => import('components/pages/1-admin/categories/l1/Tree'));
const Categories1_Tree2 = lazy(() => import('components/pages/1-admin/categories/l1/Tree2'));
const Categories1_List = lazy(() => import('components/pages/1-admin/categories/l1/List'));
const Categories1_Details = lazy(() => import('components/pages/1-admin/categories/l1/Details'));
const Categories1_Edit = lazy(() => import('components/pages/1-admin/categories/l1/Edit'));
const Categories1_New_Child = lazy(() => import('components/pages/1-admin/categories/l1/NewChild'));

const Answer_Import_History_List = lazy(() => import('components/pages/1-admin/import-history/List'));

// const Categories2_New = lazy(() => import('components/pages/1-admin/categories/l2/New'));
// const Categories2_List = lazy(() => import('components/pages/1-admin/categories/l2/List'));
const Categories2_Details = lazy(() => import('components/pages/1-admin/categories/l2/Details'));
const Categories2_Edit = lazy(() => import('components/pages/1-admin/categories/l2/Edit'));
const Categories2_New_Child = lazy(() => import('components/pages/1-admin/categories/l2/NewChild'));

const Categories3_Details = lazy(() => import('components/pages/1-admin/categories/l3/Details'));
const Categories3_Edit = lazy(() => import('components/pages/1-admin/categories/l3/Edit'));
const Categories3_New_Question = lazy(() => import('components/pages/1-admin/categories/l3/NewQuestion'));

const Questions_Details = lazy(() => import('components/pages/1-admin/categories/questions/Details'));
const Questions_Edit = lazy(() => import('components/pages/1-admin/categories/questions/Edit'));

// const Categories2_New = lazy(() => import('components/pages/1-admin/categories/l2/New'));
// const Categories2_List = lazy(() => import('components/pages/1-admin/categories/l2/List'));
// const Categories2_Details = lazy(() => import('components/pages/1-admin/categories/l2/Details'));
// const Categories2_Edit = lazy(() => import('components/pages/1-admin/categories/l2/Edit'));

// const Categories3_New = lazy(() => import('components/pages/1-admin/categories/l3/New'));
// const Categories3_List = lazy(() => import('components/pages/1-admin/categories/l3/List'));
// const Categories3_Details = lazy(() => import('components/pages/1-admin/categories/l3/Details'));
// const Categories3_Edit = lazy(() => import('components/pages/1-admin/categories/l3/Edit'));


// const Questions_New = lazy(() => import('components/pages/1-admin/questions/New'));
// const Questions_New = lazy(() => import('components/pages/1-admin/questions/New'));
// const Questions_List = lazy(() => import('components/pages/1-admin/questions/List'));
// const Questions_Details = lazy(() => import('components/pages/1-admin/questions/Details'));
// const Questions_Edit = lazy(() => import('components/pages/1-admin/questions/Edit'));

const Answers_New = lazy(() => import('components/pages/1-admin/answer-categories/New'));
const Answers_List = lazy(() => import('components/pages/1-admin/answer-categories/List'));
const Answers_Details = lazy(() => import('components/pages/1-admin/answer-categories/Details'));
const Answers_Edit = lazy(() => import('components/pages/1-admin/answer-categories/Edit'));

// const Assessments_New = lazy(() => import('components/pages/1-admin/assessments/New'));
// const Assessments_Current_List = lazy(() => import('components/pages/1-admin/assessments/current/List'));
// const Assessments_Current_Details = lazy(() => import('components/pages/1-admin/assessments/current/Details'));
// const Assessments_Edit = lazy(() => import('components/pages/1-admin/assessments/Edit'));

const Media_New = lazy(() => import('components/pages/1-admin/media/New'));
const Media_List = lazy(() => import('components/pages/1-admin/media/List'));
const Media_Details = lazy(() => import('components/pages/1-admin/media/Details'));
const Media_Edit = lazy(() => import('components/pages/1-admin/media/Edit'));
const Media_Search = lazy(() => import('components/pages/1-admin/media/Search'));

// const Media_Users_List = lazy(() => import('components/pages/1-admin/media/users/List'));
// const Media_Users_New = lazy(() => import('components/pages/1-admin/media/users/New'));
// const Media_Users_Edit = lazy(() => import('components/pages/1-admin/media/users/Edit'));


const Media_Groups_New = lazy(() => import('components/pages/1-admin/media-group/New'));
const Media_Groups_List = lazy(() => import('components/pages/1-admin/media-group/List'));
const Media_Groups_Details = lazy(() => import('components/pages/1-admin/media-group/Details'));
const Media_Groups_Edit = lazy(() => import('components/pages/1-admin/media-group/Edit'));

const Media_Tags_New = lazy(() => import('components/pages/1-admin/media-tags/New'));
const Media_Tags_List = lazy(() => import('components/pages/1-admin/media-tags/List'));
const Media_Tags_Edit = lazy(() => import('components/pages/1-admin/media-tags/Edit'));

////////////// OPERATOR
////////////// OPERATOR
////////////// OPERATOR
const O_Assessments_New = lazy(() => import('components/pages/2-operator/assessments/New'));

const O_Assessments_Current_List = lazy(() => import('components/pages/2-operator/assessments/current/List'));
const O_Assessments_Current_Details = lazy(() => import('components/pages/2-operator/assessments/current/Details'));
const O_Assessments_Current_Edit = lazy(() => import('components/pages/2-operator/assessments/current/Edit'));
const O_Assessments_Current_Access = lazy(() => import('components/pages/2-operator/assessments/current/Access'));
const O_Assessments_Current_Duplicate = lazy(() => import('components/pages/2-operator/assessments/current/Duplicate'));
const O_Assessments_Current_Results_List = lazy(() => import('components/pages/2-operator/assessments/current/Results'));
const O_Assessments_Current_Results_Details = lazy(() => import('components/pages/2-operator/assessments/current/ResultDetails'));
const O_Assessments_Current_Import = lazy(() => import('components/pages/2-operator/assessments/current/Import'));

const O_Assessments_Search = lazy(() => import('components/pages/2-operator/assessments/Search'));

const O_Assessments_Archive_List = lazy(() => import('components/pages/2-operator/assessments/archive/List'));
const O_Assessments_Archive_Details = lazy(() => import('components/pages/2-operator/assessments/archive/Details'));

const O_Reports_Last_Result = lazy(() => import('components/pages/2-operator/reports/LastResult'));

const O_Scoring_Pattern_New = lazy(() => import('components/pages/2-operator/scoring-patterns/New'));
const O_Scoring_Pattern_List = lazy(() => import('components/pages/2-operator/scoring-patterns/List'));
const O_Scoring_Pattern_Details = lazy(() => import('components/pages/2-operator/scoring-patterns/Details'));
const O_Scoring_Pattern_Edit = lazy(() => import('components/pages/2-operator/scoring-patterns/Edit'));
const O_Scoring_Pattern_Ranking = lazy(() => import('components/pages/2-operator/scoring-patterns/Ranking'));
const O_Scoring_Pattern_Calculate = lazy(() => import('components/pages/2-operator/scoring-patterns/Calculate'));
const O_Scoring_Pattern_Duplicate = lazy(() => import('components/pages/2-operator/scoring-patterns/Duplicate'));

const O_Scoring_Pattern_Formulas = lazy(() => import('components/pages/2-operator/scoring-patterns/Formulas'));

const O_Groups_List = lazy(() => import('components/pages/2-operator/groups/List'));
const O_Groups_Details = lazy(() => import('components/pages/2-operator/groups/Details'));

// const O_Categories1_Tree2 = lazy(() => import('components/pages/2-operator/categories/Tree2'));
const O_Categories_List = lazy(() => import('components/pages/2-operator/categories/List'));
const O_Categories_Details = lazy(() => import('components/pages/2-operator/categories/Details'));

const O_Categories1_Tree2 = lazy(() => import('components/pages/2-operator/categories/Tree2'));
const O_Categories1_Details = lazy(() => import('components/pages/2-operator/categories/l1/Details'));
const O_Categories2_Details = lazy(() => import('components/pages/2-operator/categories/l2/Details'));
const O_Categories3_Details = lazy(() => import('components/pages/2-operator/categories/l3/Details'));
const O_Questions_Details = lazy(() => import('components/pages/2-operator/categories/questions/Details'));

const O_Media_List = lazy(() => import('components/pages/2-operator/media/List'));
const O_Media_Details = lazy(() => import('components/pages/2-operator/media/Details'));
const O_Media_Search = lazy(() => import('components/pages/2-operator/media/Search'));

const O_Media_Groups_List = lazy(() => import('components/pages/2-operator/media-group/List'));
const O_Media_Groups_Details = lazy(() => import('components/pages/2-operator/media-group/Details'));


////////////// USER
////////////// USER
////////////// USER
const U_Categories1_Tree2 = lazy(() => import('components/pages/3-user/categories/Tree2'));
const U_Categories1_Details = lazy(() => import('components/pages/3-user/categories/l1/Details'));
const U_Categories2_Details = lazy(() => import('components/pages/3-user/categories/l2/Details'));
const U_Categories3_Details = lazy(() => import('components/pages/3-user/categories/l3/Details'));
const U_Questions_Details = lazy(() => import('components/pages/3-user/categories/questions/Details'));

const U_Assessments_Current_List = lazy(() => import('components/pages/3-user/assessments/current/List'));
const U_Assessments_Current_Import = lazy(() => import('components/pages/3-user/assessments/current/Import'));
const U_Assessments_Current_Import_History = lazy(() => import('components/pages/3-user/assessments/current/ImportHistory'));
const U_Assessments_Current_Details = lazy(() => import('components/pages/3-user/assessments/current/Details'));
const U_Assessments_Current_Media_Details = lazy(() => import('components/pages/3-user/assessments/current/MediaDetails'));
const U_Assessments_Current_Media_Entry = lazy(() => import('components/pages/3-user/assessments/current/MediaEntry'));

const U_Assessments_Search = lazy(() => import('components/pages/3-user/assessments/Search'));


function App (props) {
    const state = store.getState()
    const [fire,setFire] = useState(false)
    const location = useLocation()
    const navigate = useNavigate()
    

    // console.log('state?.appName:',state?.appName)
    // document.title = state?.appName;
    document.title = 'سامانه ارزیابی و رتبه بندی بازرگانی';

    useEffect(() => {
        // console.log('App - useEffect')
        // console.log('location?.pathname:',location?.pathname)
        // store.dispatch({ type: 'START_LOADING' });
        if(location?.pathname === '/login') {
            if(state?.user?.token) {
                navigate("/dashboard"); 
            } else if(localStorage.getItem('token')) { 
                let token = localStorage.getItem('token')
                checkToken(token)
            } else {
                navigate("/login");
            }

            setFire(true)
        } else {
            if(localStorage.getItem('token')) { 
                let token = localStorage.getItem('token')
                checkToken(token)
            } else {
                navigate("/login");
                setFire(true)
            }
        }
        // store.dispatch({ type: 'STOP_LOADING' });
    }, [])

    const checkToken = (token) => {
        // console.log('checkToken - token: ',token)
        if(token !== null && token !== undefined) {
            Axios.post('/check-token', JSON.stringify({token: token}))
            .then(async (res) => {
                let data = res.data
                let userInfo = {
                    id: data.data.id,
                    name: data.data.name,
                    lastName: data.data.last_name,
                    email: data.data.email,
                    avatar: data.data.avatar,
                    type: data.data.type,
                    token: token
                }
                store.dispatch({ type: 'LOGIN', payload: userInfo });
            })
            .catch((err) => {
                
            })
            .finally(() => {
                setFire(true)
            })
        }
    }

    const routes_prefix = {
        general_routes: '',
        admin_routes: '/a',
        operator_routes: '/o',
        user_routes: '/u',
    }

    const general_routes = [
        {
            id: 'login',
            path: '/login',
            element: 'ورود',
            type: 'public'
        },
        {
            id: 'dashboard',
            path: '/dashboard',
            type: 'protected',
            component: <Dashboard />
        },
    ]

    const admin_routes = [
        {
            id: 'users-new',
            path: '/users/new',
            type: 'protected',
            component: <Users_New />
        },
        {
            id: 'users-list',
            path: '/users/list',
            type: 'protected',
            component: <Users_List />
        },
        {
            id: 'users-details',
            path: '/users/:code/details',
            type: 'protected',
            component: <Users_Details />
        },
        {
            id: 'users-activities',
            path: '/users/:code/activities',
            type: 'protected',
            component: <Users_Activities />
        },
        {
            id: 'users-edit',
            path: '/users/:code/edit',
            type: 'protected',
            component: <Users_Edit />
        },
        {
            id: 'users-reset-password',
            path: '/users/:code/reset-password',
            type: 'protected',
            component: <Users_ResetPassword />
        },

        {
            id: 'customers-new',
            path: '/customers/new',
            type: 'protected',
            component: <Customers_New />
        },
        {
            id: 'customers-list',
            path: '/customers/list',
            type: 'protected',
            component: <Customers_List />
        },
        {
            id: 'customers-details',
            path: '/customers/:code/details',
            type: 'protected',
            component: <Customers_Details />
        },
        {
            id: 'customers-media',
            path: '/customers/:code/access',
            type: 'protected',
            component: <Customers_Access />
        },
        {
            id: 'customers-activities',
            path: '/customers/:code/activities',
            type: 'protected',
            component: <Customers_Activities />
        },
        {
            id: 'customers-edit',
            path: '/customers/:code/edit',
            type: 'protected',
            component: <Customers_Edit />
        },
        {
            id: 'customers-reset-password',
            path: '/customers/:code/reset-password',
            type: 'protected',
            component: <Customers_ResetPassword />
        },

        {
            id: 'departments-new',
            path: '/departments/new',
            type: 'protected',
            component: <Departments_New />
        },
        {
            id: 'departments-list',
            path: '/departments/list',
            type: 'protected',
            component: <Departments_List />
        },
        {
            id: 'departments-details',
            path: '/departments/:id/details',
            type: 'protected',
            component: <Departments_Details />
        },
        {
            id: 'departments-edit',
            path: '/departments/:code/edit',
            type: 'protected',
            component: <Departments_Edit />
        },
        
        {
            id: 'groups-new',
            path: '/groups/new',
            type: 'protected',
            component: <Groups_New />
        },
        {
            id: 'groups-list',
            path: '/groups/list',
            type: 'protected',
            component: <Groups_List />
        },
        {
            id: 'groups-details',
            path: '/groups/:code/details',
            type: 'protected',
            component: <Groups_Details />
        },
        {
            id: 'groups-edit',
            path: '/groups/:code/edit',
            type: 'protected',
            component: <Groups_Edit />
        },
        
        //////////// Professional Ver.
        // {
        //     id: 'categories-new',
        //     path: '/categories/new',
        //     type: 'protected',
        //     component: <Categories_New />
        // },
        // {
        //     id: 'categories-list',
        //     path: '/categories/list',
        //     type: 'protected',
        //     component: <Categories_List />
        // },
        // {
        //     id: 'categories-details',
        //     path: '/categories/:id/details',
        //     type: 'protected',
        //     component: <Categories_Details />
        // },
        // {
        //     id: 'categories-edit',
        //     path: '/categories/:id/edit',
        //     type: 'protected',
        //     component: <Categories_Edit />
        // },

        //////////// Simple Ver.
        {
            id: 'categories1-new',
            path: '/categories/new',
            type: 'protected',
            component: <Categories1_New />
        },
        {
            id: 'categories1-tree',
            path: '/categories/tree',
            type: 'protected',
            component: <Categories1_Tree2 />
        },
        {
            id: 'categories1-tree2',
            path: '/categories/tree2',
            type: 'protected',
            component: <Categories1_Tree />
        },
        {
            id: 'categories1-search',
            path: '/categories/search',
            type: 'protected',
            component: <Categories1_Search />
        },
        {
            id: 'categories1-list',
            path: '/categories/list',
            type: 'protected',
            component: <Categories1_List />
        },
        {
            id: 'categories1-details',
            path: '/categories/:l1_id',
            type: 'protected',
            component: <Categories1_Details />
        },
        {
            id: 'categories1-edit',
            path: '/categories/:l1_id/edit',
            type: 'protected',
            component: <Categories1_Edit />
        },
        {
            id: 'categories1-new-child',
            path: '/categories/:l1_id/new-child',
            type: 'protected',
            component: <Categories1_New_Child />
        },
        
        {
            id: 'categories2-details',
            path: '/categories/:l1_id/:l2_id',
            type: 'protected',
            component: <Categories2_Details />
        },
        {
            id: 'categories2-edit',
            path: '/categories/:l1_id/:l2_id/edit',
            type: 'protected',
            component: <Categories2_Edit />
        },
        {
            id: 'categories2-new-child',
            path: '/categories/:l1_id/:l2_id/new-child',
            type: 'protected',
            component: <Categories2_New_Child />
        },
        
        {
            id: 'categories3-details',
            path: '/categories/:l1_id/:l2_id/:l3_id',
            type: 'protected',
            component: <Categories3_Details />
        },
        {
            id: 'categories3-edit',
            path: '/categories/:l1_id/:l2_id/:l3_id/edit',
            type: 'protected',
            component: <Categories3_Edit />
        },
        {
            id: 'categories3-new-question',
            path: '/categories/:l1_id/:l2_id/:l3_id/new-question',
            type: 'protected',
            component: <Categories3_New_Question />
        },

        {
            id: 'categories3-question-details',
            path: '/categories/:l1_id/:l2_id/:l3_id/:q_id',
            type: 'protected',
            component: <Questions_Details />
        },
        {
            id: 'categories3-question-edit',
            path: '/categories/:l1_id/:l2_id/:l3_id/:q_id/edit',
            type: 'protected',
            component: <Questions_Edit />
        },

        {
            id: 'categories1-import-history',
            path: '/categories/import-history/list/:page?',
            type: 'protected',
            component: <Answer_Import_History_List />
        },
        
        // {
        //     id: 'categories2-list',
        //     path: '/categories/l2/:l1_id/list',
        //     type: 'protected',
        //     component: <Categories2_List />
        // },
        // {
        //     id: 'categories2-details',
        //     path: '/categories/l2/:l1_id/:id/details',
        //     type: 'protected',
        //     component: <Categories2_Details />
        // },
        // {
        //     id: 'categories2-edit',
        //     path: '/categories/l2/:l1_id/:id/edit',
        //     type: 'protected',
        //     component: <Categories2_Edit />
        // },
        // {
        //     id: 'categories2-new-child',
        //     // http://localhost:3000/a/categories/l2/4/new-child
        //     path: '/categories/l2/:l1_id/:id/new',
        //     type: 'protected',
        //     component: <Categories2_New_Child />
        // },

        // {
        //     id: 'questions-new',
        //     path: '/questions/new',
        //     type: 'protected',
        //     component: <Questions_New />
        // },
        // {
        //     id: 'questions-list',
        //     path: '/questions/list',
        //     type: 'protected',
        //     component: <Questions_List />
        // },
        // {
        //     id: 'questions-details',
        //     path: '/questions/:id/details',
        //     type: 'protected',
        //     component: <Questions_Details />
        // },
        // {
        //     id: 'questions-edit',
        //     path: '/questions/:id/edit',
        //     type: 'protected',
        //     component: <Questions_Edit />
        // },

        {
            id: 'answers-new',
            path: '/answer-categories/new',
            type: 'protected',
            component: <Answers_New />
        },
        {
            id: 'answers-list',
            path: '/answer-categories/list',
            type: 'protected',
            component: <Answers_List />
        },
        {
            id: 'answers-details',
            path: '/answer-categories/:id/details',
            type: 'protected',
            component: <Answers_Details />
        },
        {
            id: 'answers-edit',
            path: '/answer-categories/:id/edit',
            type: 'protected',
            component: <Answers_Edit />
        },

        // {
        //     id: 'assessments-new',
        //     path: '/assessments/new',
        //     type: 'protected',
        //     component: <Assessments_New />
        // },
        // {
        //     id: 'assessments-list',
        //     path: '/assessments/list',
        //     type: 'protected',
        //     component: <Assessments_List />
        // },
        // {
        //     id: 'assessments-details',
        //     path: '/assessments/:id/details',
        //     type: 'protected',
        //     component: <Assessments_Details />
        // },
        // {
        //     id: 'assessments-edit',
        //     path: '/assessments/:id/edit',
        //     type: 'protected',
        //     component: <Assessments_Edit />
        // },

        {
            id: 'media-new',
            path: '/media/new',
            type: 'protected',
            component: <Media_New />
        },
        {
            id: 'media-list',
            path: '/media/list/:page?',
            type: 'protected',
            component: <Media_List />
        },
        {
            id: 'media-details',
            path: '/media/:id/details',
            type: 'protected',
            component: <Media_Details />
        },
        {
            id: 'media-edit',
            path: '/media/:id/edit',
            type: 'protected',
            component: <Media_Edit />
        },
        // {
        //     id: 'media-users',
        //     path: '/media/:id/users/list',
        //     type: 'protected',
        //     component: <Media_Users_List />
        // },
        // {
        //     id: 'media-new-user',
        //     path: '/media/:id/users/create',
        //     type: 'protected',
        //     component: <Media_Users_New />
        // },
        // {
        //     id: 'media-edit-user',
        //     path: '/media/:id/users/:userId/edit',
        //     type: 'protected',
        //     component: <Media_Users_Edit />
        // },

        {
            id: 'media-search',
            path: '/media/search/:page?',
            type: 'protected',
            component: <Media_Search />
        },

        {
            id: 'media-group-new',
            path: '/media/groups/new',
            type: 'protected',
            component: <Media_Groups_New />
        },
        {
            id: 'media-group-list',
            path: '/media/groups/list',
            type: 'protected',
            component: <Media_Groups_List />
        },
        {
            id: 'media-group-list',
            path: '/media/groups/:id/details',
            type: 'protected',
            component: <Media_Groups_Details />
        },
        {
            id: 'media-group-list',
            path: '/media/groups/:id/edit',
            type: 'protected',
            component: <Media_Groups_Edit />
        },
        {
            id: 'media-tags-new',
            path: '/media/tags/new',
            type: 'protected',
            component: <Media_Tags_New />
        },
        {
            id: 'media-tags-list',
            path: '/media/tags/list',
            type: 'protected',
            component: <Media_Tags_List />
        },
        {
            id: 'media-tags-list',
            path: '/media/tags/:id/edit',
            type: 'protected',
            component: <Media_Tags_Edit />
        },
    ]

    const operator_routes = [
        {
            id: 'assessments-new',
            path: '/assessments/new',
            type: 'protected',
            component: <O_Assessments_New />
        },
        
        {
            id: 'assessments-current-list',
            path: '/assessments/current',
            type: 'protected',
            component: <O_Assessments_Current_List />
        },
        {
            id: 'assessments-current-details',
            path: '/assessments/current/:id/details',
            type: 'protected',
            component: <O_Assessments_Current_Details />
        },
        {
            id: 'assessments-current-edit',
            path: '/assessments/current/:id/edit',
            type: 'protected',
            component: <O_Assessments_Current_Edit />
        },
        {
            id: 'assessments-current-access',
            path: '/assessments/current/:id/access',
            type: 'protected',
            component: <O_Assessments_Current_Access />
        },
        {
            id: 'assessments-current-duplicate',
            path: '/assessments/current/:id/duplicate',
            type: 'protected',
            component: <O_Assessments_Current_Duplicate />
        },
        {
            id: 'assessments-current-import',
            path: '/assessments/current/:id/import',
            type: 'protected',
            component: <O_Assessments_Current_Import />
        },
        {
            id: 'assessments-current-results-list',
            path: '/assessments/current/:id/results',
            type: 'protected',
            component: <O_Assessments_Current_Results_List />
        },
        {
            id: 'assessments-current-results-media',
            path: '/assessments/current/:id/results/:mediaId',
            type: 'protected',
            component: <O_Assessments_Current_Results_Details />
        },

        {
            id: 'assessments-search',
            path: '/assessments/search',
            type: 'protected',
            component: <O_Assessments_Search />
        },
        {
            id: 'reports-last-result',
            path: '/reports/last-result',
            type: 'protected',
            component: <O_Reports_Last_Result />
        },

        {
            id: 'assessments-archive-list',
            path: '/assessments/archive',
            type: 'protected',
            component: <O_Assessments_Archive_List />
        },
        {
            id: 'assessments-archive-details',
            path: '/assessments/archive/:id/details',
            type: 'protected',
            component: <O_Assessments_Archive_Details />
        },
        
        {
            id: 'scoring-pattern-new',
            path: '/scoring-patterns/new',
            type: 'protected',
            component: <O_Scoring_Pattern_New />
        },
        
        {
            id: 'scoring-pattern-list',
            path: '/scoring-patterns/list',
            type: 'protected',
            component: <O_Scoring_Pattern_List />
        },
        {
            id: 'scoring-pattern-details',
            path: '/scoring-patterns/:id/details',
            type: 'protected',
            component: <O_Scoring_Pattern_Details />
        },
        {
            id: 'scoring-pattern-edit',
            path: '/scoring-patterns/:id/edit',
            type: 'protected',
            component: <O_Scoring_Pattern_Edit />
        },
        {
            id: 'scoring-pattern-calulate',
            path: '/scoring-patterns/:id/calulate',
            type: 'protected',
            component: <O_Scoring_Pattern_Calculate />
        },
        {
            id: 'scoring-pattern-rating',
            path: '/scoring-patterns/:id/ranking',
            type: 'protected',
            component: <O_Scoring_Pattern_Ranking />
        },
        {
            id: 'scoring-pattern-duplicate',
            path: '/scoring-patterns/:id/duplicate',
            type: 'protected',
            component: <O_Scoring_Pattern_Duplicate />
        },

        {
            id: 'scoring-pattern-formulas',
            path: '/scoring-patterns/formulas',
            type: 'protected',
            component: <O_Scoring_Pattern_Formulas />
        },

        {
            id: 'groups-list',
            path: '/groups/list',
            type: 'protected',
            component: <O_Groups_List />
        },
        {
            id: 'groups-details',
            path: '/groups/:code/details',
            type: 'protected',
            component: <O_Groups_Details />
        },

        {
            id: 'categories-list',
            path: '/categories/list',
            type: 'protected',
            component: <O_Categories_List />
        },
        {
            id: 'categories-details',
            path: '/categories/:id/details',
            type: 'protected',
            component: <O_Categories_Details />
        },
        {
            id: 'categories-tree',
            path: '/categories/tree',
            type: 'protected',
            component: <O_Categories1_Tree2 />
        },
        {
            id: 'categories1-details',
            path: '/categories/:l1_id',
            type: 'protected',
            component: <O_Categories1_Details />
        },
        
        {
            id: 'categories2-details',
            path: '/categories/:l1_id/:l2_id',
            type: 'protected',
            component: <O_Categories2_Details />
        },
        {
            id: 'categories3-details',
            path: '/categories/:l1_id/:l2_id/:l3_id',
            type: 'protected',
            component: <O_Categories3_Details />
        },
        {
            id: 'categories3-question-details',
            path: '/categories/:l1_id/:l2_id/:l3_id/:q_id',
            type: 'protected',
            component: <O_Questions_Details />
        },

        {
            id: 'media-list',
            path: '/media/list/:page?',
            type: 'protected',
            component: <O_Media_List />
        },
        {
            id: 'media-details',
            path: '/media/:id/details',
            type: 'protected',
            component: <O_Media_Details />
        },

        {
            id: 'media-search',
            path: '/media/search/:page?',
            type: 'protected',
            component: <O_Media_Search />
        },

        {
            id: 'media-group-list',
            path: '/media/groups/list',
            type: 'protected',
            component: <O_Media_Groups_List />
        },
        {
            id: 'media-group-details',
            path: '/media/groups/:id/details',
            type: 'protected',
            component: <O_Media_Groups_Details />
        },
    ]

    const user_routes = [
        {
            id: 'categories-tree',
            path: '/categories/tree',
            type: 'protected',
            component: <U_Categories1_Tree2 />
        },
        
        {
            id: 'categories1-details',
            path: '/categories/:l1_id',
            type: 'protected',
            component: <U_Categories1_Details />
        },
        
        {
            id: 'categories2-details',
            path: '/categories/:l1_id/:l2_id',
            type: 'protected',
            component: <U_Categories2_Details />
        },
        {
            id: 'categories3-details',
            path: '/categories/:l1_id/:l2_id/:l3_id',
            type: 'protected',
            component: <U_Categories3_Details />
        },
        {
            id: 'categories3-question-details',
            path: '/categories/:l1_id/:l2_id/:l3_id/:q_id',
            type: 'protected',
            component: <U_Questions_Details />
        },

        {
            id: 'assessments-current',
            path: '/assessments/current',
            type: 'protected',
            component: <U_Assessments_Current_List />
        },
        {
            id: 'assessments-current-import',
            path: '/assessments/current/:id/import',
            type: 'protected',
            component: <U_Assessments_Current_Import />
        },
        {
            id: 'assessments-current-import-history',
            path: '/assessments/current/:id/import-history',
            type: 'protected',
            component: <U_Assessments_Current_Import_History />
        },
        {
            id: 'assessments-current-details',
            path: '/assessments/current/:id/details',
            type: 'protected',
            component: <U_Assessments_Current_Details />
        },
        {
            id: 'assessments-current-media-details',
            path: '/assessments/current/:id/details/:mediaId',
            type: 'protected',
            component: <U_Assessments_Current_Media_Details />
        },
        {
            id: 'assessments-current-media-entry',
            path: '/assessments/current/:id/entry/:mediaId',
            type: 'protected',
            component: <U_Assessments_Current_Media_Entry />
        },
        
        {
            id: 'assessments-search',
            path: '/assessments/search',
            type: 'protected',
            component: <U_Assessments_Search />
        },
    ]
    
    if(fire)
    return (
        <Provider store={store}>
            <Suspense fallback={<PropagateLoader color="#300700" className="d-flex aligns-items-center justify-content-center" />}>
                <ToastContainer
                    position="top-left"
                    autoClose={10000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={true}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />
                <Routes>
                    <Route path="/" element={<Login redirectTo={location} />} />
                    <Route path="/login" element={<Login redirectTo={location} />} />
                    <Route path="/logout" element={<Logout />} />
                    {/* <Route path="a/users/list" element={<Protected><Users_List /></Protected>} /> */}
                    {/* <Route path="/users/list" element={<Users_List />} /> */}
                    {/* <Route path="/users/list" element={<>
                        <Suspense fallback={<div>Loading...</div>}>
                            <Users_List />
                        </Suspense>
                    </>} /> */}

                    {
                        general_routes?.filter(route => route.type === 'protected').map(route => {
                            return (
                                <Route
                                    key={route.id}
                                    path={routes_prefix.general_routes + route.path}
                                    element={
                                    <Protected redirectTo={location} >
                                        {route.component}
                                    </Protected>
                                    }
                                />
                            )
                        })
                    }
                    
                    {
                        state?.user?.type?.includes('admin') &&
                        admin_routes?.filter(route => route.type === 'protected').map(route => {
                            return (
                                <Route
                                    key={route.id}
                                    path={routes_prefix.admin_routes + route.path}
                                    element={
                                    <Protected redirectTo={location} >
                                        {route.component}
                                    </Protected>
                                    }
                                />
                            )
                        })
                    }

                    {
                        state?.user?.type?.includes('operator') &&
                        operator_routes?.filter(route => route.type === 'protected').map(route => {
                            return (
                                <Route
                                    key={route.id}
                                    path={routes_prefix.operator_routes + route.path}
                                    element={
                                    <Protected redirectTo={location} >
                                        {route.component}
                                    </Protected>
                                    }
                                />
                            )
                        })
                    }

                    {
                        state?.user?.type?.includes('user') &&
                        user_routes?.filter(route => route.type === 'protected').map(route => {
                            return (
                                <Route
                                    key={route.id}
                                    path={routes_prefix.user_routes + route.path}
                                    element={
                                    <Protected redirectTo={location} >
                                        {route.component}
                                    </Protected>
                                    }
                                />
                            )
                        })
                    }

                    <Route path="/500" element={<>500</>}></Route>
                    <Route path="/403" element={<Page403 />}></Route>
                    <Route path="*" element={<Page404 />}></Route>
                </Routes>
            </Suspense>
        </Provider>
    );
}

export default App;

// const mapStateToProps = (state) => {
//     return {
//         number: state.number,
//         user: state.user
//     };
// }

// export default connect(mapStateToProps)(App);